import YesIcon from 'assets/images/yes-icon.svg';

import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';

import Logo from 'assets/images/logo.webp';
import LoginLogo from 'assets/images/login-logo.webp';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  scrollLogo: LoginLogo,
  cptCodesIcon: YesIcon,
  portalName: 'Seva Weight Loss',
  tokenName: 'sevaWLSubscriberToken',
  globalClass: 'seva-weightloss-container',
  clientHeader: groupId,
  pricingType: 'standard-pricing',
  headerProps: {
    align: 'left'
  },
  homeTemplateProps: {
    heroSection: {
      variant: 1,
      primaryButtonProps: {},
      heroImage: '/images/home-images/home-banner-img.webp',
      verticalAlignImage: 'bottom',
      
    },
    benefitsSection: {
      variant: 3,
      columns: 2,
      heroImage: '/images/home-images/benefits.webp',
      alignCard: 'left',
    },
    subscriptionSection: {
      tabVariant: 2,
      carouselResponsiveItems: {
        desktop: 3,
      },
      showAddons: true,
      addonProps: {
        heroImage: '/images/home-images/addons-banner.webp',
        showCptCodes: true,
      },
      planCardProps: {
        buttonProps: {
          normalColor: "primary",
          normalVariant: "outlined",
          highlightedColor: "primary",
          highlightedVariant: "contained",
        },
      },
    },
    howItWorksSection: {
      variant: 2,
      alignTitle: 'left',
      heroImage: '/images/home-images/how-it-works.webp',
    },
    testimonialSection: {
      sectionClass: 'section-container',
      variant: 2,
      centerMode: true,
      heroImage: '/images/home-images/testimonial.webp',
      carouselResponsiveItem: {
        superLarge: 1,
        large: 1,
      }
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
    },
  },
  subscriptionSuccess: {
    enableBookAppointment: false,
    successImage: SuccessImage,
  },
  checkoutSection: {
    addon: {
      color: 'primary',
      iconColor: 'primary',
    },
  },
  choosePackageProps: {
    heroSection: {
      background: '/images/choose-packages/hero-background-img.webp',
      heroImage: '/images/choose-packages/hero-img.webp',
    },
  },
  savingsSummary: {},
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: false,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  footer: {
    logo: Logo
  },
  loginPage: {
    logo: LoginLogo,
    bannerImage: './images/login.webp',
  },
  theme: Theme
};

export default config;
